export default __webpack_public_path__ + "static/Buchungsjournal-1024e76f157fa4a7cc810580a47ea386.webp";